import { B as BxfChatCanvasConstants } from './p-7397c455.js';
import { A as AriaAttr } from './p-d7c3b756.js';

var BxfChatCanvasModeEnum;
(function (BxfChatCanvasModeEnum) {
    BxfChatCanvasModeEnum["STANDALONE"] = "standalone";
    BxfChatCanvasModeEnum["EMBEDDED"] = "embedded";
})(BxfChatCanvasModeEnum || (BxfChatCanvasModeEnum = {}));

var BxfChatCanvasWidthEnum;
(function (BxfChatCanvasWidthEnum) {
    BxfChatCanvasWidthEnum[BxfChatCanvasWidthEnum["XS"] = 360] = "XS";
    BxfChatCanvasWidthEnum[BxfChatCanvasWidthEnum["LMS"] = 424] = "LMS";
    BxfChatCanvasWidthEnum[BxfChatCanvasWidthEnum["XL"] = 606] = "XL";
    BxfChatCanvasWidthEnum[BxfChatCanvasWidthEnum["INITIAL"] = 626] = "INITIAL";
})(BxfChatCanvasWidthEnum || (BxfChatCanvasWidthEnum = {}));

var BxfChatCanvasActiveContentEnum;
(function (BxfChatCanvasActiveContentEnum) {
    BxfChatCanvasActiveContentEnum["LOGIN"] = "login";
    BxfChatCanvasActiveContentEnum["ERROR"] = "error";
    BxfChatCanvasActiveContentEnum["UNVERIFIED"] = "unverified-advisor";
    BxfChatCanvasActiveContentEnum["LOADING"] = "loading";
    BxfChatCanvasActiveContentEnum["LOADING_ERROR"] = "loading-error";
    BxfChatCanvasActiveContentEnum["CHAT"] = "chat";
    BxfChatCanvasActiveContentEnum["RECENT"] = "recent";
    BxfChatCanvasActiveContentEnum["IMPORTANT_INFO"] = "important-information";
})(BxfChatCanvasActiveContentEnum || (BxfChatCanvasActiveContentEnum = {}));

const { CANVAS_RECENT_ARIA_LABEL } = BxfChatCanvasConstants;
const RecentPromptsAriaConfig = {
    [AriaAttr.LABEL]: CANVAS_RECENT_ARIA_LABEL,
};

export { BxfChatCanvasModeEnum as B, RecentPromptsAriaConfig as R, BxfChatCanvasWidthEnum as a, BxfChatCanvasActiveContentEnum as b };
